export interface OptionItem {
  value: string
  uuid: string
}

export enum MovementDirection {
  DOWN = 'down',
  UP = 'up'
}
